export const CATEGORY_COMMUNITY = 'Community';

export const CATEGORY_CATHOLIC = 'Catholic';

export const CATEGORIES_MCO = [
    'Lutheran',
    'Jewish',
    'Baptist',
    'Synagogue',
    'Temple',
    'Orthodox',
    'Eastern Orthodox',
    'Episcopal',
    'Greek Orthodox',
    'Non-denominational',
    'Ukrainian Orthodox',
    'Presbyterian',
    'Secular',
    'United Church of Christ',
    'Methodist',
    'Pentecostal',
    'Chamber of Commerce',
    'Community Center',
    'Membership Organization',
    'Municipality',
    'Retirement Community',
    'Senior Agency',
    'Senior Center',
];
